import { errorReport404 } from '@utiles/errorReport';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';

/**
 * 创建跳转到错误页面（404页面）的方法
 * 返回的函数会在调用时使用 this.getMainHost() 获取主域名
 * @returns {Function} jumpErrorPage 方法
 */
export const createJumpErrorPage = () => {
  return function jumpErrorPage() {
    let hostName = this.getMainHost();
    // 统一所有404地址
    let href = `//gabres.${hostName}/page404/`;

    errorReport404();
    window.location.href = getGlobalGetGotoLink({ link: href });
  };
};
